export const OWNER = "owner"
export const CREW = "crew"
export const SKIPPER = "skipper"
